<tmo-page-titles [pageTitle]="pageTitle"></tmo-page-titles>
